import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

// NOTE (Listing Richness, 2026-09-27): the Available Discounts IMAGE OVERLAY was
// removed from the PDP hero. Only the Haul Star badge stays on the listing image
// now; discounts are listed as TEXT in a "Discounts Available" body section
// between The Rundown and Trailer Details (see SectionDiscountsMaybe). The
// generic "Discounts Available" badge still appears on the SEARCH/FEED card
// image (ListingCard) to lift CTR.
const SectionGallery = props => {
  const { listing, variantPrefix, onManageDisableScrolling = () => false } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        listing={listing}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        onManageDisableScrolling={onManageDisableScrolling}
      />
    </section>
  );
};

export default SectionGallery;
